(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
/* Move the accordion block into the product description where #accordion-hook exists */
(function(){
  function moveAccordion(){
    var hook = document.querySelector('#accordion-hook');                    // placeholder inside description
    var acc  = document.querySelector('#product-{{ section.id }} .product-accordion-block'); // accordion block root
    if (hook && acc) hook.replaceWith(acc);                                  // inject block at the hook
  }
  document.addEventListener('DOMContentLoaded', moveAccordion);              // on page load
  document.addEventListener('shopify:section:load', moveAccordion);          // when customizing theme
})();

  } catch(e) { console.error(e); }
})();
})();
